import gql from 'graphql-tag';

const UPDATE_BATCH = gql`
  mutation Mutation($deviceSerialNo: String!, $batch: String!) {
    updateBatch(deviceSerialNo: $deviceSerialNo, batch: $batch) {
      code
    }
  }
`;

export default UPDATE_BATCH;
